import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, inject } from '@angular/core';
import { ScrollService } from '../services/scroll/scroll.service';
import _ from 'lodash';

@Directive({
    selector: '[adm4Scrollable]',
    standalone: false
})
export class ScrollableDirective implements OnChanges {
  private renderer = inject(Renderer2);
  private scrollAreaElemRef = inject(ElementRef);
  private scrollService = inject(ScrollService);

  @Input() selectedClass: string | null;
  @Input() removeSelector: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedClass']) {
      this.changeSelectionAndScrollPosition();
    }
  }

  private changeSelectionAndScrollPosition(): void {
    const deselectElements = this.scrollAreaElemRef.nativeElement.querySelectorAll(this.removeSelector);
    if (deselectElements) {
      _.forEach(deselectElements, (element) => this.renderer.removeClass(element, 'selected'));
    }
    if (!_.isNil(this.selectedClass)) {
      const selectedElement = this.scrollAreaElemRef.nativeElement.querySelector('.'.concat(this.selectedClass));
      if (!selectedElement) {
        console.warn(`Could not find help entry for ${this.selectedClass}`);
        return;
      }
      this.renderer.addClass(selectedElement, 'selected');
      setTimeout(() => this.scrollService.scrollIntoViewIfNeeded(this.scrollAreaElemRef.nativeElement, selectedElement));
    }
  }
}

